export default function workListing () {
	document.querySelectorAll('.work-listing').forEach((section) => {
		bindCardVideos(section, '.card');
		const bar = section.querySelector('.nav-cover-bar');
		if (! bar) return;
		const header = document.querySelector('.site-header');
		const syncBar = () => {
			const box = section.getBoundingClientRect();
			const line = header ? header.getBoundingClientRect().bottom : 0;
			bar.classList.toggle('is-fixed', box.top <= line && box.bottom > line);
		};
		syncBar();
		window.addEventListener('scroll', syncBar, { passive: true });
		document.addEventListener('scroll', syncBar, { passive: true, capture: true });
		window.addEventListener('resize', syncBar);
	});
}

function bindCardVideos (section, cardSelector) {
	const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
	if (reduce || ! fine) return;

	section.querySelectorAll(cardSelector).forEach((card) => {
		const video = card.querySelector('.hover-video');
		if (! video) return;

		let rewindTimer = 0;

		const show = () => {
			if (card.matches(':hover')) video.classList.add('is-playing');
		};

		video.addEventListener('playing', show);

		card.addEventListener('pointerenter', () => {
			window.clearTimeout(rewindTimer);
			const started = video.play();
			if (started && typeof started.catch === 'function') started.catch(() => {});
		});

		card.addEventListener('pointerleave', () => {
			video.classList.remove('is-playing');
			video.pause();
			window.clearTimeout(rewindTimer);
			rewindTimer = window.setTimeout(() => {
				if (! card.matches(':hover')) video.currentTime = 0;
			}, 200);
		});
	});
}
